angular.module('components.caPriceRangeInput', [])
    .component('caPriceRangeInput', {
        templateUrl: 'main/product/pricelisteditor/components/pricerangeinput.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            priceRangeItem: '<',
            maxPriceFieldName: '<',
            minPriceFieldName: '<',
            onPriceRangeItemChanged: '&'
        },
        controller: controller
    });

// @ngInject  
function controller($scope, $q) {
    var vm = this;
    var inputBox = {};

    console.log("maxPriceFieldName is: ", vm.maxPriceFieldName);
    console.log("minPriceFieldName is: ", vm.minPriceFieldName);

    var oldPriceRangeItem = {};
    var valueBeforeEditing = "";

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.inputBoxDisplayValue = "";

    vm.inputBoxFocused = inputBoxFocused;
    vm.inputBoxBlurred = inputBoxBlurred;
    vm.handleInputChange = handleInputChange;

    vm.captureInputBox = captureInputBox;
    vm.getInputBoxStyle = getInputBoxStyle;
    vm.handleKeypress = handleKeypress;

    vm.markForRemoval = markForRemoval;

    function onInit() {
        $scope.$watch(function() { return vm.priceRangeItem.maxPrice; }, function() {
            constructDisplayValue();
        });

        $scope.$watch(function() { return vm.priceRangeItem.minPrice; }, function() {
            constructDisplayValue();
        });

        $scope.$watch(function() { return vm.priceRangeItem.previousMaxPrice; }, function() {
            constructDisplayValue();
        });

        $scope.$watch(function() { return vm.priceRangeItem.previousMinPrice; }, function() {
            constructDisplayValue();
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

    function inputBoxFocused() {
        storePriceRangeItem();
        if (vm.priceRangeItem.isCalculatedPrice) {
            vm.inputBoxDisplayValue = "";
            storeInputValue();
        } else {
            vm.inputBoxDisplayValue = vm.priceRangeItem[vm.maxPriceFieldName].toString();
            storeInputValue();
        }
    }

    function inputBoxBlurred() {
        if (vm.inputBoxDisplayValue === "" && vm.priceRangeItem[vm.maxPriceFieldName] === vm.priceRangeItem[vm.minPriceFieldName]) {
            vm.inputBoxDisplayValue = vm.priceRangeItem[vm.maxPriceFieldName];
        } else if (vm.priceRangeItem[vm.maxPriceFieldName] !== vm.priceRangeItem[vm.minPriceFieldName]) {
            vm.inputBoxDisplayValue = vm.priceRangeItem[vm.minPriceFieldName].toString() + " - " + vm.priceRangeItem[vm.maxPriceFieldName].toString();
        }
    }

    function handleInputChange() {
        var inputValueToNumber = _.toNumber(vm.inputBoxDisplayValue);
        if (!isNaN(inputValueToNumber)) {
            vm.priceRangeItem[vm.minPriceFieldName] = inputValueToNumber;
            vm.priceRangeItem[vm.maxPriceFieldName] = inputValueToNumber;
            vm.priceRangeItem.isCalculatedPrice = false;

            // Callback
            vm.onPriceRangeItemChanged({priceRangeItem: vm.priceRangeItem});
        } else {
            revertInputValue();
        }
    }

    function captureInputBox(ib) {
        inputBox = ib;
    }

    function handleKeypress(ev) {
        if (ev.key === 'Escape' && ev.charCode === 0) {
            revertPriceRangeItem();
        }
    }

    function markForRemoval() {
        vm.priceRangeItem.shouldBeDeleted = true;
        vm.priceRangeItem.isCalculatedPrice = true;

        vm.onPriceRangeItemChanged({priceRangeItem: vm.priceRangeItem});
    }

    function getInputBoxStyle() {
        var style = {};

        if (!vm.priceRangeItem.isPriceOnAnyPriceList && vm.priceRangeItem.priceListId !== 0) {
            style['background-color'] = 'transparent';
            style['color'] = 'transparent';
        } else if (vm.priceRangeItem.isCalculatedPrice) {
            style['background-color'] = '#dddddd';
            style['color'] = '#777777';
        } else {
            style['background-color'] = 'transparent';
            style['color'] = '#000000';
        }

        return style;
    }

    function storeInputValue() {
        valueBeforeEditing = vm.inputBoxDisplayValue;
    }

    function revertInputValue() {
        vm.inputBoxDisplayValue = valueBeforeEditing;
    }

    function storePriceRangeItem() {
        oldPriceRangeItem = angular.copy(vm.priceRangeItem);
    }

    function revertPriceRangeItem() {
        vm.priceRangeItem[vm.minPriceFieldName] = oldPriceRangeItem[vm.minPriceFieldName];
        vm.priceRangeItem[vm.maxPriceFieldName] = oldPriceRangeItem[vm.maxPriceFieldName];
        vm.priceRangeItem.isCalculatedPrice = oldPriceRangeItem.isCalculatedPrice;
        constructDisplayValue();

        // Callback
        vm.onPriceRangeItemChanged({priceRangeItem: vm.priceRangeItem});
    }

    function constructDisplayValue() {
        if (vm.priceRangeItem[vm.maxPriceFieldName] === vm.priceRangeItem[vm.minPriceFieldName]) {
            vm.inputBoxDisplayValue = vm.priceRangeItem[vm.maxPriceFieldName].toString();
            storeInputValue();
        } else {
            vm.inputBoxDisplayValue = vm.priceRangeItem[vm.minPriceFieldName].toString() +  ' - ' + vm.priceRangeItem[vm.maxPriceFieldName].toString();
            storeInputValue();
        }
    }
}
